import { render, staticRenderFns } from "./CorpSupplier.vue?vue&type=template&id=a6022d42"
import script from "./CorpSupplier.vue?vue&type=script&lang=js"
export * from "./CorpSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports